import { render, staticRenderFns } from "./ScriptWithSupplierPricesModal.vue?vue&type=template&id=52685282&scoped=true"
import script from "./ScriptWithSupplierPricesModal.vue?vue&type=script&lang=js"
export * from "./ScriptWithSupplierPricesModal.vue?vue&type=script&lang=js"
import style0 from "./ScriptWithSupplierPricesModal.vue?vue&type=style&index=0&id=52685282&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52685282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52685282')) {
      api.createRecord('52685282', component.options)
    } else {
      api.reload('52685282', component.options)
    }
    module.hot.accept("./ScriptWithSupplierPricesModal.vue?vue&type=template&id=52685282&scoped=true", function () {
      api.rerender('52685282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supplier-prices/ScriptWithSupplierPricesModal.vue"
export default component.exports